import { lazy } from "react";
const Dashboard = lazy(() => import("../pages/ProfilePage/ProfilePage"));
const History = lazy(() => import("../pages/History/History"));
const ModifyBooking = lazy(() => import("../pages/History/ModifyBooking"));
const TransactionAndHistory = lazy(() => import("../pages/Transaction&History/Transaction&History"));
const UserReview = lazy(() => import("../pages/Reviews/UserReview"));



const routes = [
    {
        path: "/user/profile",
        component: Dashboard,
    },
    {
        path: "/user/mybookings",
        component: History,
    },
    {
        path: "/user/cancelbooking",
        component: ModifyBooking,
    },
    {
        path: "/user/transactionsandhistory",
        component: TransactionAndHistory,
    },
    {
        path: "/user/review",
        component: UserReview,
    },
];

export default routes;